import PictureInPictureIcon from "@material-ui/icons/PictureInPicture";

const restaurantProposition = {
  icon: PictureInPictureIcon,
  options: { label: "Restaurant Proposition" },
};

export default restaurantProposition;
